// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"76c499b9","453":"0ddd8a3a","777":"fbad98dd"}[chunkId] + ".chunk.js";
};